import type { ReactNode } from "react";
import styles from "./AppShell.module.css";

interface Props {
  sidebar: ReactNode;
  children: ReactNode;
}

export function AppShell({ sidebar, children }: Props) {
  return (
    <div className={styles.shell}>
      <aside className={styles.sidebarSlot}>{sidebar}</aside>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
